export const STATUS_KEY: string = 'status';

